import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslationCoreModule } from '@qtek/libs/translation-core';
import { TableTask } from '@qtek/shared/models';
import { STATUS_MAP } from '../../tasks.constants';

@Component({
  selector: 'qt-task-table-status',
  templateUrl: './task-table-status.component.html',
  styleUrls: ['./task-table-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatMenuModule, TranslationCoreModule],
})
export class TaskTableStatusComponent {
  // Inputs
  readonly task = input.required<TableTask>();
  readonly status = input.required<'todo' | 'done' | 'pending'>();
  readonly canUpdate = input<boolean>(true);
  readonly allowExpiredUploadStatusChange = input<boolean>(false);

  // Outputs
  readonly statusChange = output<{
    task: TableTask;
    status: string;
  }>();

  // Component state and computed values
  protected readonly taskStatuses = STATUS_MAP;
  protected readonly statusMenuOptions = ['todo', 'done'] as const;
  protected readonly isMenuOpenState = signal(false);
  protected readonly isStatusEditable = computed(() => {
    const task = this.task();
    const taskType = task.actionType?.toLowerCase();
    const status = this.status();

    //Hotfix 6/22: allow changing status for overdue tasks
    const isExpiredUploadEditable =
      taskType === 'upload_doc' &&
      this.allowExpiredUploadStatusChange() &&
      !!task.expired;

    return (
      this.canUpdate() &&
      (taskType !== 'upload_doc' || isExpiredUploadEditable) &&
      taskType !== 'send_email' &&
      taskType !== 'approval' &&
      status !== 'pending'
    );
  });

  protected onStatusClick(event: Event): void {
    if (this.isStatusEditable()) {
      event.stopPropagation();
    }
  }

  protected onStatusChange(status: string): void {
    if (status === this.status()) {
      return;
    }
    this.statusChange.emit({ task: this.task(), status });
  }

  protected onMenuOpened(): void {
    this.isMenuOpenState.set(true);
  }

  protected onMenuClosed(): void {
    this.isMenuOpenState.set(false);
  }
}
